import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(),
        getByLog: state => logId => {
            return state.objs.filter(e => e.log === logId);
        }
    },
    mutations: {
        ...functions.createDefaultMutations()
    },
    actions: {
        ...functions.createDefaultActionsWithStore()
    },
}